import React, { useState } from 'react';
import '../../styles/RegistrationForm.css';
import { QrCode } from '../../assets/index'
import { postStudentRegistration } from '../../services/getAllApi';
import Swal from 'sweetalert2'

const RegistrationForm = () => {
    const [currentSection, setCurrentSection] = useState(0);
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        mobile: "",
        DOB: "",
        email: "",
        father_first_name: "",
        father_last_name: "",
        mother_first_name: "",
        mother_last_name: "",
        home_mobile: "",
        gender: "",
        nationality: "",
        street_address: "",
        city: "",
        pin_code: "",
        reason: "",
        payment_screenshot: "",
        transaction_id: "",
        agree_to_terms: 1,
    });

    const sections = [
        'Personal Information',
        'Family Details',
        'Other Details',
        'Payment Section'
    ];

    const handleNext = () => {
        if (currentSection < sections.length - 1) {
            setCurrentSection(currentSection + 1);
        }
    };

    const handlePrev = () => {
        if (currentSection > 0) {
            setCurrentSection(currentSection - 1);
        }
    };

    const handleChange = (e) => {
        const { id, value, type, checked, files } = e.target;
        setFormData({
            ...formData,
            [id]: type === 'checkbox' ? checked : 
                   type === 'file' ? files[0] : 
                   value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        const formDataToSubmit = new FormData();
    
        for (const key in formData) {
            if (formData.hasOwnProperty(key)) {
                formDataToSubmit.append(key, formData[key]);
            }
        }
    
        try {
            const response = await postStudentRegistration(formData);
            
            if (response.status === 201 || response.status === 200) {
                Swal.fire({
                    icon: "success",
                    title: "Registration Successful!",
                    showConfirmButton: false,
                    timer: 1500
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: `${response.response?.data?.message || "Registration Failed"}!`,
                    showConfirmButton: false,
                    timer: 1500
                });
            }
        } catch (error) {
            console.error('Error submitting the form:', error);
            Swal.fire({
                icon: "error",
                title: "An error occurred",
                text: error.message,
                showConfirmButton: true
            });
        }
    };

    const progress = ((currentSection + 1) / sections.length) * 100;

    return (
        <div className="registration-container w-full mx-auto  px-4 overflow-hidden">
            <h1 className="register-heading text-center mb-6">Registration Form</h1>
            
            <div className="progress-bar mb-6">
                <div className="progress" style={{ width: `${progress}%` }}></div>
            </div>
            
            <form id="registrationForm" onSubmit={handleSubmit} className="w-full">
                {/* Personal Information Section */}
                {currentSection === 0 && (
                    <div className="form-section active">
                        <h2 className="section-title">Personal Information</h2>

                        <div className="register-two-input flex flex-col sm:flex-row gap-4 mb-4">
                            <div className="form-group w-full">
                                <label htmlFor="first_name">First Name</label>
                                <input 
                                    type="text"
                                    id="first_name"
                                    value={formData.first_name}
                                    onChange={handleChange}
                                    required
                                    className='w-full p-2 border rounded'
                                />
                            </div>
                            <div className="form-group w-full">
                                <label htmlFor="last_name">Last Name</label>
                                <input
                                    type="text"
                                    id="last_name"
                                    value={formData.last_name}
                                    onChange={handleChange}
                                    required
                                    className='w-full p-2 border rounded'
                                />
                            </div>
                        </div>

                        <div className="register-two-input flex flex-col sm:flex-row gap-4 mb-4">
                            <div className="form-group w-full">
                                <label htmlFor="DOB">Date of Birth</label>
                                <input
                                    type="date"
                                    id="DOB"
                                    value={formData.DOB}
                                    onChange={handleChange}
                                    required
                                    className='w-full p-2 border rounded'
                                />
                            </div>
                            <div className="form-group w-full">
                                <label>Gender</label>
                                <div className="gender-options flex gap-4">
                                    {['Male', 'Female', 'Others'].map(gender => (
                                        <label key={gender} className="flex items-center">
                                            <input
                                                type="radio"
                                                id="gender"
                                                value={gender}
                                                checked={formData.gender === gender}
                                                onChange={handleChange}
                                                required
                                                className='mr-2'
                                            />
                                            {gender}
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="register-two-input flex flex-col sm:flex-row gap-4">
                            <div className="form-group w-full">
                                <label htmlFor="mobile">Phone Number</label>
                                <input
                                    type="tel"
                                    id="mobile"
                                    value={formData.mobile}
                                    onChange={handleChange}
                                    required
                                    className='w-full p-2 border rounded'
                                />
                            </div>
                            <div className="form-group w-full">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    className='w-full p-2 border rounded'
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/* Family Details Section */}
                {currentSection === 1 && (
                    <div className="form-section active">
                        <h2 className="section-title">Family Details</h2>

                        <div className="register-two-input flex flex-col sm:flex-row gap-4 mb-4">
                            <div className="form-group w-full">
                                <label htmlFor="father_first_name">Father First Name</label>
                                <input
                                    type="text"
                                    id="father_first_name"
                                    value={formData.father_first_name}
                                    onChange={handleChange}
                                    required
                                    className='w-full p-2 border rounded'
                                />
                            </div>
                            <div className="form-group w-full">
                                <label htmlFor="father_last_name">Father Last Name</label>
                                <input
                                    type="text"
                                    id="father_last_name"
                                    value={formData.father_last_name}
                                    onChange={handleChange}
                                    required
                                    className='w-full p-2 border rounded'
                                />
                            </div>
                        </div>

                        <div className="register-two-input flex flex-col sm:flex-row gap-4 mb-4">
                            <div className="form-group w-full">
                                <label htmlFor="mother_first_name">Mother First Name</label>
                                <input
                                    type="text"
                                    id="mother_first_name"
                                    value={formData.mother_first_name}
                                    onChange={handleChange}
                                    required
                                    className='w-full p-2 border rounded'
                                />
                            </div>
                            <div className="form-group w-full">
                                <label htmlFor="mother_last_name">Mother Last Name</label>
                                <input
                                    type="text"
                                    id="mother_last_name"
                                    value={formData.mother_last_name}
                                    onChange={handleChange}
                                    required
                                    className='w-full p-2 border rounded'
                                />
                            </div>
                        </div>

                        <div className="register-two-input flex flex-col sm:flex-row gap-4">
                            <div className="form-group w-full">
                                <label htmlFor="home_mobile">Home Mobile Number</label>
                                <input
                                    type="tel"
                                    id="home_mobile"
                                    value={formData.home_mobile}
                                    onChange={handleChange}
                                    required
                                    className='w-full p-2 border rounded'
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/* Other Details Section */}
                {currentSection === 2 && (
                    <div className="form-section active">
                        <h2 className="section-title">Other Details</h2>

                        <div className="register-two-input flex flex-col sm:flex-row gap-4 mb-4">
                            <div className="form-group w-full">
                                <label htmlFor="nationality">Nationality</label>
                                <input
                                    type="text"
                                    id="nationality"
                                    value={formData.nationality}
                                    onChange={handleChange}
                                    required
                                    className='w-full p-2 border rounded'
                                />
                            </div>
                            <div className="form-group w-full">
                                <label htmlFor="street_address">Address</label>
                                <input
                                    type="text"
                                    id="street_address"
                                    value={formData.street_address}
                                    onChange={handleChange}
                                    required
                                    className='w-full p-2 border rounded'
                                />
                            </div>
                        </div>

                        <div className="register-two-input flex flex-col sm:flex-row gap-4 mb-4">
                            <div className="form-group w-full">
                                <label htmlFor="city">City</label>
                                <input
                                    type="text"
                                    id="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                    required
                                    className='w-full p-2 border rounded'
                                />
                            </div>
                            <div className="form-group w-full">
                                <label htmlFor="pin_code">Pin Code</label>
                                <input
                                    type="text"
                                    id="pin_code"
                                    value={formData.pin_code}
                                    onChange={handleChange}
                                    required
                                    className='w-full p-2 border rounded'
                                />
                            </div>
                        </div>

                        <div className="register-two-input flex flex-col sm:flex-row gap-4">
                            <div className="form-group w-full">
                                <label htmlFor="reason">Reason</label>
                                <input
                                    type="text"
                                    id="reason"
                                    value={formData.reason}
                                    onChange={handleChange}
                                    required
                                    className='w-full p-2 border rounded'
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/* Payment Details Section */}
                {currentSection === 3 && (
                    <div className="form-section active">
                        <h2 className="section-title">Payment Details</h2>

                        <div className="qr-code-container flex justify-center mb-6">
                            <div className="w-1/2">
                                <img
                                    src={QrCode}
                                    alt="QR Code for Payment"
                                    className="qr-code w-full"
                                />
                            </div>
                        </div>

                        <div className="register-two-input flex flex-col sm:flex-row gap-4 mb-4">
                            <div className="form-group w-full">
                                <label htmlFor="payment_screenshot">Upload Payment Screenshot</label>
                                <input
                                    type="file"
                                    id="payment_screenshot"
                                    onChange={handleChange}
                                    accept="image/*"
                                    required
                                    className='w-full p-2 border rounded'
                                />
                            </div>
                        </div>

                        <div className='tr_id'>
                            <div className="register-two-input flex flex-col sm:flex-row gap-4">
                                <div className="form-group w-full">
                                    <label htmlFor="transaction_id">Transaction ID</label>
                                    <input
                                    type="text"
                                    id="transaction_id"
                                    value={formData.transaction_id}
                                    onChange={handleChange}
                                    required
                                    className='w-full p-2 border rounded'/>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="buttons flex justify-between mt-6">
                    {currentSection > 0 && (
                        <button
                            type="button"
                            className="btn-prev register-buttons px-4 py-2 bg-gray-300 rounded"
                            onClick={handlePrev}
                        >
                            Previous
                        </button>
                    )}

                    {currentSection < sections.length - 1 && (
                        <button
                            type="button"
                            className="btn-next register-buttons px-4 py-2 bg-blue-500 text-white rounded ml-auto"
                            onClick={handleNext}
                        >
                            Next
                        </button>
                    )}

                    {currentSection === sections.length - 1 && (
                        <button
                            type="submit"
                            className="btn-submit lg:w-[10rem] sm:w-[5rem] register-buttons px-4 py-2 bg-green-500 text-white rounded w-full"
                       id="btn" >
                            Submit
                        </button>
                    )}
                </div>
            </form>
        </div>
    );
};

export default RegistrationForm;